<template>
    <div class="slider-container">
        <!-- 轮播图图片区域 -->
        <div class="slider" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd">
            <div class="slider-images" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
                <div class="imgBox" v-for="(image, index) in images" :key="index">
                    <div class="mask">
                        <p class="title">{{ titleDe[index].title }}</p>
                        <span class="con">{{ titleDe[index].con }}</span>
                    </div>
                    <img class="imah" :src="image" @error="handleImageError" style="" />
                </div>
            </div>
        </div>
        <!-- 进度条区域 -->
        <div class="progress-bars">
            <div style="cursor: pointer" v-for="(_, index) in images" :key="index" @click="goToSlide(index)"
                class="proTex" @mouseenter="handleMouseEnter(index)" @mouseleave="handleMouseLeave(index)">
                <div class="progress-bar">
                    <div class="progress" :style="{ width: `${progress[index]}%` }"></div>
                </div>
                <div class="imgtitle" :class="{
                    'hover-color': isHovered2 === index,
                    hovCo: isHovered === index,
                }">
                    {{ imgtext[index].title }}
                </div>
                <div class="imgtext" :class="{
                    'hover-color': isHovered2 === index,
                    hovCo: isHovered === index,
                }">
                    {{ imgtext[index].con }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            images: [
                require("../assets/图片1.png"),
                require("../assets/图片2.png"),
                require("../assets/图片3.png"),
                require("../assets/图片4.png"),
                require("../assets/图片5.png"),
                require("../assets/图片6.png"),
            ],
            isHovered: null,
            isHovered2: null,
            currentIndex: 0,
            progress: [], // 存储每个进度条的进度
            slideInterval: null,
            progressInterval: null,
            slideDuration: 5000, // 每张图片展示时间（毫秒）
            touchStartX: 0,
            touchEndX: 0,
            threshold: 50, // 滑动阈值，达到该值才切换图片
            imgtext: [
                { title: "虚拟训练系统", con: "让我们开启自己的元宇宙" },
                {
                    title: "综合仿真视景系统",
                    con: "从现实到虚拟，从虚拟到现实。",
                },
                {
                    title: "人机工效评估系统",
                    con: "人在环工效分析，可深度定制。",
                },
                {
                    title: "安全疏散仿真系统",
                    con: "快速场景构建，算法控制NPC，真人数据采集。",
                },
                {
                    title: "红外&SAR仿真软件",
                    con: "基于工程物理计算的实时红外和SAR图像仿真。",
                },
                { title: "三维电子手册", con: "让冰冷的设备和信息联动起来。" },
            ],
            titleDe: [
                {
                    title: "虚拟训练系统（VTS）",
                    con: "VTS是一套针对大型复杂装备的模拟仿真训练解决方案，千村科技采用世界顶级的Unreal/Unity作为渲染和交互引擎，在构建出真实设备的三维模型基础上根据设备实际的操作和维护逻辑而定制开发出的系统。此解决方案可大大降低训练成本，节约训练时间，提高训练的安全性，实现规模化训练，可应用在航空、航天、船舶、能源、医疗和工业等行业。",
                },
                {
                    title: "综合仿真视景系统（MetaEarth）",
                    con: "MetaEarth是一套开放的三维地球虚拟仿真系统，可仿真出晴朗美丽的天空，绚丽多变的云彩，巍峨磅礴的山川河流，波澜壮阔的海洋，灯火辉煌的城市，繁忙的机场，拥堵的城市交通，茂密的森林，广阔的草原，四季变换的气候和雷雨交加的天气。MetaEarth现已广泛应用于飞行视景仿真、战场态势推演和军事模拟演练等方向。（图片中的机型做了特殊处理，您懂的！）",
                },
                {
                    title: "人机工效评估系统（MetaErgo）",
                    con: "MetaErgo是一套开放式的人因工程分析评估系统，支持离线和在线模式的人机工效分析，可应用于数字样机的快速验证和评审。",
                },
                {
                    title: "安全疏散仿真系统",
                    con: "安全疏散仿真系统可用于快速构建特定场景下虚拟现实环境，从而可以面向公众的突发事件体验、自救互救和培训技术；可用于系统性的提取和分析疏散人员的多模态数据，实现对受灾人群生理、心理反应的定量评估，有利于研究突发事件情况下应急疏散人员心理及行为特性。",
                },
                {
                    title: "红外&SAR仿真软件",
                    con: "红外&SAR仿真软件是一套基于热物理及雷达回波工程模拟计算，结合大气传输特性及复杂背景环境的传感器仿真软件， 实现目标与环境场景的实时动态高分辨率图像(可见光、红外、SAR等)生成，可用于陆、海、空平台上多波段成像仿真。",
                },
                {
                    title: "三维电子手册（IETM）",
                    con: "IETM是针对大型复杂装备的一套数字化可交互技术手册，可提高技术资料使用和维护的便捷性, 提高装备故障诊断效率和维修的精准度, 增强数据互操作性、传递与使用的实时性和共享性, 从而有效提高装备保障能力和可靠性, 并降低资料制作、管理和维护的各项费用。",
                },
            ],
            isLoading: true,
        };
    },
    mounted() {
        // 预加载图片
        this.preloadImages().then(() => {
            this.isLoading = false;
            // 初始化进度条数组
            this.progress = new Array(this.images.length).fill(0);
            this.startAutoSlide();
        });
    },
    beforeDestroy() {
        this.stopAutoSlide();
    },
    watch: {
        progressInterval() {
            // console.log(this.currentIndex);
            this.isHovered = this.currentIndex;
        },
    },
    methods: {
        preloadImages() {
            return Promise.all(
                this.images.map((image) => {
                    return new Promise((resolve, reject) => {
                        const img = new Image();
                        img.src = image;
                        img.onload = resolve;
                        img.onerror = reject;
                    });
                })
            );
        },
        startAutoSlide() {
            clearInterval(this.slideInterval);
            clearInterval(this.progressInterval);
            this.slideInterval = setInterval(() => {
                this.nextSlide();
            }, this.slideDuration);
            this.startProgress();
        },
        stopAutoSlide() {
            clearInterval(this.slideInterval);
            clearInterval(this.progressInterval);
        },
        startProgress() {
            clearInterval(this.progressInterval);
            this.resetAllProgress();
            this.progressInterval = setInterval(() => {
                const currentProgress = this.progress[this.currentIndex];
                if (currentProgress < 100) {
                    const increment = 100 / (this.slideDuration / 10);
                    this.progress = [...this.progress];
                    this.progress[this.currentIndex] = Math.min(
                        currentProgress + increment,
                        100
                    );
                } else {
                    clearInterval(this.progressInterval);
                    this.nextSlide();
                    this.startProgress();
                }
            }, 10);
        },
        nextSlide() {
            this.clearTimers();
            this.currentIndex = (this.currentIndex + 1) % this.images.length;
            this.resetProgress();
        },
        prevSlide() {
            this.clearTimers();
            this.currentIndex =
                (this.currentIndex - 1 + this.images.length) %
                this.images.length;
            this.resetProgress();
        },
        clearTimers() {
            clearInterval(this.slideInterval);
            clearInterval(this.progressInterval);
        },
        resetProgress() {
            this.resetAllProgress();
            this.startProgress();
            this.slideInterval = setInterval(() => {
                this.nextSlide();
            }, this.slideDuration);
        },
        resetAllProgress() {
            this.progress = this.progress.map(() => 0);
        },
        goToSlide(index) {
            this.clearTimers();
            this.currentIndex = index;
            this.resetProgress();
        },
        onTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
        },
        onTouchMove(event) {
            // 可以在这里添加滑动时的视觉反馈，例如轻微移动图片
        },
        onTouchEnd(event) {
            this.touchEndX = event.changedTouches[0].clientX;
            const deltaX = this.touchEndX - this.touchStartX;
            if (deltaX > this.threshold) {
                this.prevSlide();
            } else if (deltaX < -this.threshold) {
                this.nextSlide();
            }
        },
        handleMouseEnter(index) {
            this.isHovered2 = index;
        },
        handleMouseLeave(event) {
            this.isHovered2 = null;
        },
        handleImageError(event) {
            console.error('图片加载失败:', event.target.src);
            // 可以在这里添加默认图片
        },
    },
};
</script>

<style lang="scss" scoped>
/* 轮播图容器样式 */
.slider-container {
    width: 100%;
    /* 高度根据实际情况调整 */
    height: auto;
    max-height: 800px;
    position: relative;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    overflow: hidden;
}

/* 轮播图图片区域样式 */
.slider {
    width: 100%;
    height: 800px;
    overflow: hidden;
}

.slider-images {
    display: flex;
    height: 800px;
    transition: transform 0.5s ease-in-out;
}

.imgBox img {
    min-width: 100%;
    height: auto;
    height: 100%;
    object-fit: cover;
}

.imgBox {
    min-width: 100%;
    height: auto;
    position: relative;
    /* height: 100%; */
    /* object-fit: cover; */
}

/* .imgBox img { */
/* min-width: 100%; */
/* height: auto; */
/* height: 800px; */
/* object-fit: cover; */
/* } */

/* 进度条区域样式 */
.progress-bars {
    position: absolute;
    height: 95px;
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 30px;
    z-index: 10;
}

.progress-bar {
    width: 190px;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.3);
    overflow: hidden;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.progress {
    height: 100%;
    background-color: #287ca6;
    transition: width 0.1s linear;
}

.mask {
    position: absolute;
    top: 0;
    /* left: 0; */
    width: 30%;
    height: 60%;
    background-color: rgba(255, 255, 255, 0.1);
    /* 半透明背景 */
    backdrop-filter: blur(2px);
    /* 模糊滤镜 */
    -webkit-backdrop-filter: blur(2px);
    /* Safari 浏览器前缀 */
    justify-content: center;
    align-items: center;
    opacity: 1;
    transition: opacity 0.3s ease;
    z-index: 5;
    padding: 20px;
    border-radius: 10px;

    /* 添加圆角 */
    .title {
        font-weight: 700;
        font-size: 3pc;
        color: #fff;
    }

    .con {
        font-weight: 700;
        font-size: 1pc;
        color: #fff;
        line-height: 40px;
    }
}

.imgtitle {
    font-size: 15px;
    font-weight: 700;
    padding-top: 15px;
    color: rgb(255, 255, 255, 0.6);
    margin-bottom: 10px;
}

.imgtext {
    font-size: 11px;
    color: rgb(255, 255, 255, 0.6);
    text-overflow: ellipsis;
    white-space: normal;
    font-weight: 700;
}

.proTex:hover {
    /* color: #000 !important; */
}

.hover-color {
    // color: rgb(0, 0, 0, 0.6);
    color: rgb(255, 255, 255);
}

.hovCo {
    color: rgb(255, 255, 255);
}

@media (max-width: 798px) {
    .slider-container {
        height: 647px;

        .slider {
            height: 650px;

            .slider-images {
                // min-width: 100%;
                height: 100%;

                .imgBox {
                    .mask {
                        position: relative;
                        max-width: 100%;
                        min-width: 0;
                        width: 94%;
                        height: 60%;
                        background-color: #000;
                        border-radius: 0;
                        border-bottom: 1px solid #000;

                        // height: 35%;
                        .title {
                            // color: #000;
                            margin: 0;
                            font-size: 28px;
                        }

                        .con {
                            // color: #000;
                        }
                    }

                    img {
                        max-width: 100%;
                        min-width: 0;
                        height: auto;
                    }
                }
            }
        }
    }

    .progress-bars {
        width: 100%;
        height: 0;
        gap: 20px;

        .proTex {
            width: 15%;

            .progress-bar {
                width: 100%;
            }

            .imgtitle {
                display: none;
            }

            .imgtext {
                display: none;
            }
        }
    }
}
</style>